import React from 'react';
import { Outlet } from 'react-router-dom';
import SliverNav from './SliverNav';
import DashboardHeader from './DashboardHeader';
import { LiveFeedProvider } from '../components/live/LiveFeedProvider';
import LiveTickerStrip from '../components/LiveTickerStrip';

const ShellLayout = () => (
  <LiveFeedProvider>
    <div className="h-screen w-screen flex bg-black text-white overflow-hidden font-sans">
      <SliverNav />
      <div className="flex-1 flex flex-col min-w-0">
        <DashboardHeader />
        <main className="flex-1 overflow-hidden p-6 dot-matrix-bg">
          <Outlet />
        </main>
        <LiveTickerStrip />
        <footer className="px-6 py-2 border-t border-white/10 flex justify-between font-mono-tech text-[9px] text-neutral-600 uppercase tracking-[0.3em]">
          <span>System_Status: Nominal</span>
          <span>GlassView_v1.0 // Branch→Town→Region→National→Group</span>
          <span>&copy;2026 PG GLASS AFRICA</span>
        </footer>
      </div>
    </div>
  </LiveFeedProvider>
);

export default ShellLayout;
